import { memo, useCallback, useState } from "react";
import { StyleSheet } from "react-native-unistyles";
import { View, Button, Banner } from "@src/components";
import { FormInput } from "@src/components/FormInput";

export type CreateTenantAdminFormData = {
  email: string;
};

interface CreateTenantAdminFormProps {
  onSave: (data: CreateTenantAdminFormData) => void;
  saveLabel?: string;
}

export const CreateTenantAdminForm = memo(({ onSave, saveLabel = "Invite" }: CreateTenantAdminFormProps) => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState<{ email?: string }>({});

  const handleEmailChange = useCallback((value: string) => {
    setEmail(value);
    if (value.trim()) setErrors((prev) => ({ ...prev, email: undefined }));
  }, []);

  const handleSave = useCallback(() => {
    const newErrors: { email?: string } = {};
    if (!email.trim()) newErrors.email = "Enter email address";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSave({ email });
    setErrors({});
  }, [email, onSave]);

  return (
    <View>
      <Banner
        variant="info"
        message="Granting organisation admin gives this user full administrative access to all sites, cameras, and user permissions across the organisation."
        containerStyle={styles.banner}
      />

      <View gap="3xl">
        <FormInput
          placeholder="Email address"
          value={email}
          onChangeText={handleEmailChange}
          size="medium"
          keyboardType="email-address"
          autoCapitalize="none"
          error={errors.email}
        />
      </View>

      <Button variant="primary" label={saveLabel} size="md" onPress={handleSave} style={styles.saveButton} />
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  banner: {
    marginBottom: theme.spacing["4xl"],
  },
  saveButton: {
    marginTop: theme.spacing["4xl"],
  },
}));
